var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alarm-clock 1",
    clipPath: "url(#clip0_201_1732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_280048832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_215462136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 31.8529C10.6875 31.8529 4.78125 25.9467 4.78125 18.6342C4.78125 11.392 10.6875 5.41541 18 5.41541C25.3125 5.41541 31.2188 11.392 31.2188 18.6342C31.2188 25.9467 25.3125 31.8529 18 31.8529ZM18 6.25916C11.1797 6.25916 5.625 11.8138 5.625 18.6342C5.625 25.4545 11.1797 31.0092 18 31.0092C24.8203 31.0092 30.375 25.4545 30.375 18.6342C30.375 11.8138 24.8203 6.25916 18 6.25916Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0703 9.49353C17.8594 9.49353 17.6484 9.35291 17.6484 9.07166V7.31384C17.6484 7.10291 17.8594 6.89197 18.0703 6.89197C18.3516 6.89197 18.4922 7.10291 18.4922 7.31384V9.07166C18.4922 9.35291 18.3516 9.49353 18.0703 9.49353Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8203 12.3763C24.75 12.3763 24.6094 12.306 24.5391 12.2357C24.3984 12.0951 24.3984 11.8138 24.5391 11.6732L25.8047 10.4076C25.9453 10.267 26.2266 10.267 26.3672 10.4076C26.5078 10.5482 26.5078 10.8295 26.3672 11.0404L25.1016 12.2357C25.0312 12.306 24.9609 12.3763 24.8203 12.3763Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3203 19.1967H27.5625C27.3516 19.1967 27.1406 18.9857 27.1406 18.7748C27.1406 18.4935 27.3516 18.3529 27.5625 18.3529H29.3203C29.5312 18.3529 29.7422 18.4935 29.7422 18.7748C29.7422 18.9857 29.5312 19.1967 29.3203 19.1967Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215461776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9453 27.142C25.8047 27.142 25.7344 27.142 25.6641 27.0013L24.3984 25.806C24.2578 25.5951 24.2578 25.3842 24.3984 25.1732C24.5391 25.0326 24.8203 25.0326 24.9609 25.1732L26.2266 26.4388C26.3672 26.5795 26.3672 26.8607 26.2266 27.0013C26.1562 27.142 26.0156 27.142 25.9453 27.142Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9297 30.3763C17.6484 30.3763 17.5078 30.2357 17.5078 29.9545V28.1967C17.5078 27.9857 17.6484 27.7748 17.9297 27.7748C18.1406 27.7748 18.3516 27.9857 18.3516 28.1967V29.9545C18.3516 30.2357 18.1406 30.3763 17.9297 30.3763Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215463096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91406 27.0013C9.84375 27.0013 9.70312 27.0013 9.63281 26.8607C9.49219 26.7201 9.49219 26.4388 9.63281 26.2982L10.8984 25.0326C11.0391 24.892 11.3203 24.892 11.4609 25.0326C11.6016 25.2435 11.6016 25.4545 11.4609 25.6654L10.1953 26.8607C10.125 27.0013 10.0547 27.0013 9.91406 27.0013Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 18.9857H6.67969C6.46875 18.9857 6.25781 18.7748 6.25781 18.5638C6.25781 18.3529 6.46875 18.142 6.67969 18.142H8.4375C8.64844 18.142 8.85938 18.3529 8.85938 18.5638C8.85938 18.7748 8.64844 18.9857 8.4375 18.9857Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3203 12.2357C11.1797 12.2357 11.1094 12.2357 11.0391 12.0951L9.77344 10.8998C9.63281 10.6888 9.63281 10.4779 9.77344 10.267C9.91406 10.1263 10.1953 10.1263 10.3359 10.267L11.6016 11.5326C11.7422 11.6732 11.7422 11.9545 11.6016 12.0951C11.5312 12.2357 11.3906 12.2357 11.3203 12.2357Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 34.1029C13.8516 34.1029 9.98438 32.4857 7.10156 29.6029C4.14844 26.6498 2.53125 22.7826 2.53125 18.6342C2.53125 14.556 4.14844 10.6185 7.10156 7.73572C9.98438 4.78259 13.8516 3.23572 18 3.23572C22.1484 3.23572 26.0156 4.78259 28.8984 7.73572C31.8516 10.6185 33.4688 14.556 33.4688 18.6342C33.4688 22.7826 31.8516 26.6498 28.8984 29.6029C26.0156 32.4857 22.1484 34.1029 18 34.1029ZM18 4.07947C9.91406 4.07947 3.375 10.6185 3.375 18.6342C3.375 26.7201 9.91406 33.2592 18 33.2592C26.0859 33.2592 32.625 26.7201 32.625 18.6342C32.625 10.6185 26.0859 4.07947 18 4.07947Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_215463000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82031 36.0013C6.75 36.0013 6.60938 35.931 6.53906 35.8607C6.39844 35.7201 6.39844 35.4388 6.53906 35.2279L10.3359 31.431C10.4766 31.2904 10.7578 31.2904 10.9688 31.431C11.1094 31.642 11.1094 31.9232 10.9688 32.0638L7.10156 35.8607C7.03125 35.931 6.96094 36.0013 6.82031 36.0013Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215463120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1797 36.0013C29.0391 36.0013 28.9688 35.931 28.8984 35.8607L25.0312 32.0638C24.8906 31.9232 24.8906 31.642 25.0312 31.431C25.2422 31.2904 25.5234 31.2904 25.6641 31.431L29.4609 35.2279C29.6016 35.4388 29.6016 35.7201 29.4609 35.8607C29.3906 35.931 29.25 36.0013 29.1797 36.0013Z",
    fill: "#DE1717"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_215461512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4531 21.7982C16.3828 21.7982 16.3125 21.7279 16.2422 21.7279C16.0312 21.5873 15.9609 21.306 16.1016 21.1654L17.5078 18.6342L15.1172 13.431C14.9766 13.2201 15.1172 12.9388 15.3281 12.8685C15.5391 12.7279 15.75 12.8685 15.8906 13.0795L18.3516 18.4935C18.4219 18.6342 18.4219 18.7748 18.3516 18.8451L16.8047 21.5873C16.7344 21.6576 16.5937 21.7982 16.4531 21.7982Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_215463264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5234 6.04822C25.4531 6.04822 25.3828 6.04822 25.3125 5.97791C25.1015 5.90759 25.0312 5.62634 25.1719 5.41541L26.2969 3.51697C26.3672 3.30603 26.6484 3.23572 26.8594 3.30603C27.0703 3.44666 27.1406 3.72791 27 3.93884L25.875 5.83728C25.8047 5.97791 25.664 6.04822 25.5234 6.04822Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8984 5.34509C28.6875 5.34509 28.5469 5.34509 28.4062 5.20447L24.3984 2.88416C23.9766 2.67322 23.8359 2.11072 24.1172 1.68884L24.8203 0.423218C24.9609 0.21228 25.2422 0.00134277 25.5937 0.00134277C25.7344 0.00134277 25.875 0.0716553 26.0156 0.141968L30.0234 2.46228C30.4453 2.67322 30.5859 3.23572 30.375 3.65759L29.6016 4.92322C29.4609 5.20447 29.1797 5.34509 28.8984 5.34509ZM25.5937 0.845093H25.5234L24.8203 2.11072V2.18103L28.8281 4.50134H28.8984L29.6016 3.23572C29.6016 3.23572 29.6016 3.23572 29.6016 3.16541L25.5937 0.845093Z",
    fill: "#DE1717"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_215463408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4762 6.04822C10.3356 6.04822 10.195 5.97791 10.1247 5.83728L8.99968 3.93884C8.85905 3.72791 8.92936 3.44666 9.1403 3.30603C9.35124 3.23572 9.63249 3.30603 9.7028 3.51697L10.8278 5.41541C10.9684 5.62634 10.8981 5.90759 10.6872 5.97791C10.6169 6.04822 10.5466 6.04822 10.4762 6.04822Z",
    fill: "#DE1717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_215462712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10155 5.34509C6.8203 5.34509 6.53905 5.20447 6.39842 4.92322L5.62499 3.65759C5.41405 3.23572 5.55467 2.67322 5.97655 2.46228L9.98436 0.141968C10.125 0.0716553 10.2656 0.00134277 10.4062 0.00134277C10.7578 0.00134277 11.0391 0.21228 11.1797 0.423218L11.8828 1.68884C12.1641 2.11072 12.0234 2.67322 11.6016 2.88416L7.59374 5.20447C7.45311 5.34509 7.31249 5.34509 7.10155 5.34509ZM10.4062 0.845093L6.39842 3.16541V3.23572L7.10155 4.50134H7.17186L11.1797 2.18103C11.1797 2.18103 11.1797 2.18103 11.1797 2.11072L10.4766 0.845093H10.4062Z",
    fill: "#DE1717"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_1732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.00134277)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClock);
export default __webpack_public_path__ + "static/media/alarm-clock.1270fdb31e326c8253779d8e6794c2da.svg";
export { ForwardRef as ReactComponent };